import ActivityPlaceModule from '@/modules/activityPlace';
import ActorsModule from '@/modules/actors';
import AdminModule from '@/modules/admin';
import CompanyModule from '@/modules/company';
import ConfigurationModule from '@/modules/configuration';
import DashboardModule from '@/modules/dashboard';
import { CMSPageLoad, FaqsPageLoad } from '@/modules/home/pages';
import ProposalFilesModule from '@/modules/proposalFiles';
import ProposalRequestModule from '@/modules/proposalRequest';
import ToolsModule from '@/modules/tools';
import VerificationModule from '@/modules/verification';

export default {
  Dashboard: {
    exact: false,
    path: '/dashboard',
    component: DashboardModule
  },
  Actors: {
    exact: false,
    path: '/actors',
    component: ActorsModule
  },
  ProposalFiles: {
    exact: false,
    path: '/proposal-files',
    component: ProposalFilesModule
  },
  Verification: {
    exact: false,
    path: '/verification',
    component: VerificationModule
  },
  ProposalRequest: {
    exact: false,
    path: '/proposal-request',
    component: ProposalRequestModule
  },
  Tools: {
    exact: false,
    path: '/tools',
    component: ToolsModule
  },
  Configuration: {
    exact: false,
    path: '/configuration',
    component: ConfigurationModule
  },
  Company: {
    exact: false,
    path: '/company',
    component: CompanyModule
  },
  User: {
    exact: false,
    path: '/admin',
    component: AdminModule
  },
  FAQs: {
    exact: true,
    path: '/preguntas-frecuentes',
    component: FaqsPageLoad
  },
  ActivityPlace: {
    exact: false,
    path: '/activityplace',
    component: ActivityPlaceModule
  },
  Home: {
    exact: true,
    path: '/',
    permissions: ['USER:READ'],
    component: CMSPageLoad
  },
};
